import React, {useEffect} from 'react';
import {Routes, Route, Navigate, useLocation} from 'react-router-dom';

// pages
import {
  LoginPage,
  LoansPage,
  ContactPage,
  ProfilePage,
  LoanDetailsPage,
  NotFoundPage,
  ArticlesPage,
  ArticleDetailsPage,
  SubscriptionsPage,
  SubscriptionDetailsPage,
  DashboardPage,
} from '../pages';

// services
import {CreditBookApi} from '../shared/services/ApiService';
import {UserConfigManager} from '../shared/services/UserConfigManager';

// components
import {SideBar} from '../shared/components/';
import {TopBar} from '../shared/components';

// styles
import {RoutesContainer, Wrapper} from './Routes-styles';

// hooks
import {useTheme} from '@emotion/react';
import {useScreenWidth} from '../shared/hooks';
import {checkHasFeatureAccess} from '../shared/helpers';

const RoutesComponent = () => {
  const isAuthenticated = CreditBookApi.tokenManager.isAuthenticated();
  const theme = useTheme();
  const width = useScreenWidth();
  const userConfig = UserConfigManager.getConfig();
  const {pathname} = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <RoutesContainer>
      {isAuthenticated && width > theme.screenBreakpoint.md.value && (
        <SideBar />
      )}
      {isAuthenticated && width <= theme.screenBreakpoint.md.value && (
        <TopBar />
      )}
      <Wrapper>
        <Routes>
          {!isAuthenticated && (
            <>
              <Route path="/login" element={<LoginPage />} />
              <Route path="*" element={<Navigate to="/login" />} />
            </>
          )}
          {isAuthenticated && (
            <>
              <Route path="/login" element={<Navigate to="/dashboard" />} />
              <Route path="/" element={<Navigate to="/dashboard" />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="*" element={<NotFoundPage />} />

              {checkHasFeatureAccess(userConfig, 'loans') && (
                <>
                  <Route path="/loans" element={<LoansPage />} />
                  <Route path="/loans/:loanId" element={<LoanDetailsPage />} />
                </>
              )}
              {checkHasFeatureAccess(userConfig, 'subscriptions') && (
                <>
                  <Route
                    path="/subscriptions"
                    element={<SubscriptionsPage />}
                  />
                  <Route
                    path="/subscriptions/:subscriptionId"
                    element={<SubscriptionDetailsPage />}
                  />
                </>
              )}
              {checkHasFeatureAccess(userConfig, 'contentLibrary') && (
                <>
                  <Route
                    path="/articles"
                    element={<ArticlesPage />}
                  />
                  <Route
                    path="/articles/:articleType"
                    element={<ArticlesPage />}
                  />
                  <Route
                    path="/articles/:articleType/:articleId"
                    element={<ArticleDetailsPage />}
                  />
                </>
              )}
            </>
          )}
        </Routes>
      </Wrapper>
    </RoutesContainer>
  );
};
export default RoutesComponent;
